export enum PopoverHorizontalAlign {
  Center = 'Center',
  Left = 'Left',
  Right = 'Right',
  Stretch = 'Stretch'
}
